import { use } from 'react';
import { FormProvider } from 'react-hook-form';
import Dialog from '@mui/material/Dialog';
import DetailsPopUpContent from 'shared/components/details-pop-up-content/details-pop-up-content';

import TenantDetailsHeader from 'features/tenants/components/tenant-details-header/tenant-details-header';
import TenantDetailsInformation from 'features/tenants/components/tenant-details-information/tenant-details-information';
import TenantMonitoringDetails from 'features/tenants/components/tenant-monitoring-details/tenant-monitoring-details';
import TenantsProviderContext from 'features/tenants/providers/tenants-provider/contexts/tenants-provider-context';
import styles from './tenant-details.module.scss';

const TenantDetails = (): React.JSX.Element => {
  const { closeDetails, form, submitTenant } = use(TenantsProviderContext);

  return (
    <Dialog
      open={true}
      onClose={() => closeDetails()}
      className={styles.tenantDetails}
      slotProps={{
        paper: {
          className: styles.tenantDetailsPopupPaper,
        },
      }}
    >
      <FormProvider {...form}>
        <DetailsPopUpContent
          onSubmit={form.handleSubmit(submitTenant)}
          leftContent={<TenantDetailsInformation />}
          rightContent={<TenantMonitoringDetails />}
          header={<TenantDetailsHeader />}
        />
      </FormProvider>
    </Dialog>
  );
};

export default TenantDetails;
